/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {

  /* footer extend */
  document.querySelectorAll('.footer__block--menu').forEach(function (menuBlock) {
    const header = menuBlock.querySelector('.footer__block__title');
    const content = menuBlock.querySelector('.footer__quicklinks');
  
    header.addEventListener('click', function () {
      content.style.display = (content.style.display === 'block') ? 'none' : 'block';
      header.classList.toggle('active');
    });
  });


})();


/* Quick add - bigger tap area around the plus (14px each side, invisible); YMAL size boxes match home page widths; close size boxes once a size is picked so they don't sit over the cart drawer */
(function () {
  var style = document.createElement('style');
  style.textContent =
    '.related-extended .floating-swatches-wrapper .radio__fieldset .radio__button { flex: 0 0 auto !important; width: auto !important; min-width: 0 !important; max-width: none !important; }' +
    '.related-extended .floating-swatches-wrapper .radio__fieldset .radio__button label { width: auto !important; min-width: 0 !important; }' +
    '.product-item .btn-add-to-cart::after { content: ""; position: absolute; top: -14px; right: -14px; bottom: -14px; left: -14px; }';
  document.head.appendChild(style);

  function closeQuickAdd() {
    document.querySelectorAll('.btn-add-to-cart.clicked').forEach(function (btn) {
      btn.classList.remove('clicked');
    });
  }

  document.addEventListener('change', function (event) {
    if (event.target.classList && event.target.classList.contains('ws-preorder')) return;
    if (event.target.closest && event.target.closest('.floating-swatches-wrapper')) {
      setTimeout(closeQuickAdd, 300);
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('.floating-swatches-wrapper .product__submit__add')) {
      setTimeout(closeQuickAdd, 300);
    }
  }, true);
})();


/* Wait and Save sizes on product cards (07.10.26)
   Cards whose Wait and Save preorder product is live get the class .preorder-product.
   On those cards, sold-out sizes are shown as normal (not crossed out), and tapping
   one opens the product page with that size selected instead of quick adding. */
(function () {
  var style = document.createElement('style');
  style.textContent =
    '.product-item .floating-swatches-wrapper .radio__button.ws-preorder-size label { border: 1px solid #727272 !important; color: #000 !important; opacity: 1 !important; }' +
    '.product-item .floating-swatches-wrapper .radio__button.ws-preorder-size label:hover { border-color: #000 !important; }' +
    '.product-item .floating-swatches-wrapper .radio__button.ws-preorder-size label:before { display: none !important; }' +
    '.product-item .floating-swatches-wrapper .radio__button.ws-preorder-size { opacity: 1 !important; cursor: pointer; }';
  document.head.appendChild(style);

  function markSizes() {
    document.querySelectorAll('.product-item.preorder-product').forEach(function (item) {
      item.querySelectorAll('.floating-swatches-wrapper .radio__button').forEach(function (button) {
        var input = button.querySelector('input[data-single-option-selector]');
        if (!input) return;
        var soldOut = input.disabled || input.classList.contains('sold-out') || input.classList.contains('unavailable') || button.classList.contains('sold-out');
        if (soldOut && !input.classList.contains('ws-preorder')) {
          input.classList.add('ws-preorder');
          button.classList.add('ws-preorder-size');
        }
      });
    });
  }

  function goToProduct(input) {
    var item = input.closest('.product-item');
    var link = item && item.querySelector('a[data-product-link]');
    if (!link) return;
    var url = link.getAttribute('href');
    var variantId = '';
    item.querySelectorAll('.productVariant_option p').forEach(function (p) {
      if (p.getAttribute('data-name') === input.value) variantId = p.getAttribute('data-id');
    });
    if (variantId) url += (url.indexOf('?') === -1 ? '?' : '&') + 'variant=' + variantId;
    window.location.href = url;
  }

  document.addEventListener('click', function (event) {
    var t = event.target;
    if (!t || !t.closest) return;
    var button = t.closest('.floating-swatches-wrapper .radio__button.ws-preorder-size');
    if (!button) return;
    var input = button.querySelector('input.ws-preorder');
    if (!input) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    goToProduct(input);
  }, true);

  var queued = false;
  function queueMark() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; markSizes(); });
  }

  markSizes();
  document.addEventListener('DOMContentLoaded', markSizes);
  window.addEventListener('load', markSizes);
  new MutationObserver(queueMark).observe(document.documentElement, { childList: true, subtree: true });
})();


/* Cart drawer - clicking the dimmed area outside the cart panel closes the cart.
   On desktop the dim background is the cart drawer element itself (the visible
   panel is .cart-drawer_inner), so the theme's own "click outside" check never
   fires there. This closes the cart when the click lands on the dim area. */
(function () {
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    // Only clicks that land on the drawer element itself...
    var drawer = target.closest('[data-cart-drawer]');
    if (!drawer) return;

    // ...and not inside the cart panel (or the upsell popup beside it)
    if (target.closest('.cart-drawer_inner, .cart_drawer_popup')) return;

    // Close the same way the cart's own X button does
    var closeButton = drawer.querySelector('.cart-drawer__close[data-cart-toggle]');
    if (window.cart && typeof window.cart.closeCartDrawer === 'function') {
      window.cart.closeCartDrawer();
    } else if (closeButton) {
      closeButton.click();
    }
  });
})();


/* Product page size buttons - the selected outline moves the moment a size is
   touched (09.10.26).
   On phones the page does a lot of work when a size changes (theme, apps, tracking),
   and the browser cannot redraw until all of it has finished, so the outline stayed
   on the old size for a moment. On touch-down we mark the touched size straight away
   (cf-size-tapped) and the CSS in comma-custom.css outlines it instead of the old
   one. Once the size has actually changed the marks are removed and the normal
   "checked" outline takes over. Only the main product's sizes are affected. */
(function () {
  var PENDING = 'cf-size-pending'; // on the size group while a tap is in progress
  var TAPPED = 'cf-size-tapped';   // on the size that was just touched
  var fallbackTimer = null;

  // Returns the size button for a target inside the main product's size group
  function mainSizeButton(target) {
    if (!target || !target.closest) return null;
    var button = target.closest('.radio__fieldset .radio__button');
    if (!button || !button.closest('[id^="shopify-section-"][id$="__main"]')) return null;
    return button;
  }

  function clearPending() {
    clearTimeout(fallbackTimer);
    document.querySelectorAll('.radio__fieldset.' + PENDING).forEach(function (fieldset) {
      fieldset.classList.remove(PENDING);
    });
    document.querySelectorAll('.radio__button.' + TAPPED).forEach(function (button) {
      button.classList.remove(TAPPED);
    });
  }

  // Touch-down on a size: outline it immediately
  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    var button = mainSizeButton(event.target);
    if (!button) return;
    var input = button.querySelector('input[type="radio"]');
    if (!input || input.checked || input.disabled) return;
    clearPending();
    button.closest('.radio__fieldset').classList.add(PENDING);
    button.classList.add(TAPPED);
    // Safety net: never leave the temporary outline on for long
    fallbackTimer = setTimeout(clearPending, 1500);
  }, { capture: true, passive: true });

  // Lifting off somewhere else (e.g. finger slid off) - drop the temporary outline
  document.addEventListener('pointerup', function (event) {
    var button = mainSizeButton(event.target);
    if (!button || !button.classList.contains(TAPPED)) clearPending();
  }, true);

  // Scrolling started instead of a tap
  document.addEventListener('pointercancel', clearPending, true);

  // The size has changed - the real checked outline takes over
  document.addEventListener('change', function (event) {
    if (mainSizeButton(event.target)) clearPending();
  }, true);
})();


/* Preorder products - sold-out sizes say "Sold Out" (10.10.26)
   On a product that is itself a preorder (its form has the hidden
   "Sale type: Pre-order" input, data-product-preorder), the main button's
   "Add Pre Order to Cart" text is fixed in the product form liquid, so it
   never changed when a sold-out size was picked - the button greyed out but
   still said "Add Pre Order to Cart". Now, when the selected size is sold out
   (the theme puts variant--soldout on the form wrapper), the text reads
   "Sold Out", and goes back to "Add Pre Order to Cart" on an available size.
   The greyed/disabled look and the Notify me button are left to the theme and
   kbite-notify-button.js. Normal products and Wait and Save
   (#PreOrderAddBtn) are not touched. */
(function () {
  var SAVED = 'data-cf-preorder-text'; // the original preorder wording

  function updateButton(button) {
    var form = button.closest('form');
    if (!form || !form.querySelector('[data-product-preorder]')) return; // not a preorder product
    // The fixed preorder label (the theme's own label has data-add-to-cart-text)
    var label = button.querySelector('.label-wrapper > .btn__text:not([data-add-to-cart-text])');
    if (!label) return;
    if (!label.hasAttribute(SAVED)) label.setAttribute(SAVED, label.textContent);

    var wrapper = button.closest('.form__wrapper, [data-form-wrapper]');
    var soldOut = wrapper
      ? wrapper.classList.contains('variant--soldout') || wrapper.classList.contains('variant--unavailable')
      : button.disabled;
    var soldOutText = (window.theme && theme.strings && theme.strings.soldOut) || 'Sold Out';
    var text = soldOut ? soldOutText : label.getAttribute(SAVED);
    if (label.textContent !== text) label.textContent = text;
  }

  function updateAll() {
    document.querySelectorAll('[id^="shopify-section-"][id$="__main"] #MainAddToCartBtn').forEach(updateButton);
  }

  function start() {
    updateAll();
    // Re-check whenever the theme changes the form state (class / disabled)
    document.querySelectorAll('[id^="shopify-section-"][id$="__main"]').forEach(function (section) {
      new MutationObserver(updateAll).observe(section, {
        attributes: true,
        attributeFilter: ['class', 'disabled'],
        subtree: true
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
